const Footer = () => {
    return (
        <div className="flex bg-[#351dab] text-white font-bold h-[250px] items-center">
            <h1 className="basis-1/4 text-center">MyCargo</h1>
            <p className="basis-2/4 text-center">&copy; MyCargo | All rights reserved.</p>
            <h1 className="basis-1/4 text-center">MyCargo <span className="text-yellow-500">|</span> Universe</h1>
        </div>
    );
};

export default Footer;